module.exports = __webpack_public_path__ + "static/media/S-task10_adjMatrix.9ddb2123.png";